import { patientApiRequest, ApiAuth } from "../../../lib/api";
import { PatientPlansResponse, PatientPlansResponseSchema } from "./types";

// The patient's own plans. Who the patient is comes from the verified session,
// never from the request — nothing here can name anybody else.
export const plansApi = {
  async get(auth: ApiAuth): Promise<PatientPlansResponse> {
    const data = await patientApiRequest(auth, {
      method: "POST",
      url: "/patient-app/plans/get",
      data: {},
    });
    return PatientPlansResponseSchema.parse(data);
  },
};
